<template>
    <div class="small-panel">
        <alert-message v-if="errorMessage"></alert-message>
    </div>
</template>

<script>
    import AlertMessage from "./AlertMessage";
    import {mapMutations,mapGetters} from 'vuex';
    export default {
        name: "NoAlias",
        components: {AlertMessage},
        computed: {
            ...mapGetters(["errorMessage"]),
        },
        created(){
            this.setErrorMessage("Please ensure that alias is present in the URL like '/apps/new-guides/cs-coach'.")
        },
        methods: {
            ...mapMutations(["setErrorMessage"]),
        }
    }
</script>

<style scoped>

</style>